import { render } from "./Privacy.vue?vue&type=template&id=5a0f60bf"
const script = {}

import exportComponent from "E:\\project2\\skin-web\\战魂旅人\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__